import React from 'react';
import { ServicePageLayout } from '../../components/feature/service-page/ServicePageLayout';

const OnePlusServicePage: React.FC = () => {
  return (
    <ServicePageLayout
      seo={{
        title: "OnePlus Repair Kochi - OnePlus Service Center Kerala | Device Doctor",
        description: "Professional OnePlus repair services in Kochi, Kerala. Expert OnePlus device repair for OnePlus 12, 11, 10, 9, 8 series. Screen replacement, battery repair, charging port issues. Fast turnaround with genuine parts.",
        keywords: "oneplus repair kochi, oneplus service center kerala, oneplus screen repair, oneplus battery replacement, oneplus repair vyttila, oneplus charging port repair",
        structuredData: { "@context": "https://schema.org", "@type": "Service", "name": "OnePlus Repair Services", "brand": { "@type": "Brand", "name": "OnePlus" } }
      }}
      hero={{
        title: "OnePlus Service Centre in Kochi",
        subtitle: "Expert OnePlus mobile repair services with genuine parts, transparent pricing, and same-day service. All-Kerala Courier Services available.",
        stats: [{ value: '500+', label: 'OnePlus Repairs' }, { value: '4.9★', label: 'Customer Rating' }, { value: 'Same Day', label: 'Service Available' }],
        backgroundImage: "/assets/oneplus-hero-bg.jpg"
      }}
      serviceList={{
        introParagraph: "Professional repair solutions for all OnePlus models with genuine parts and expert technicians.",
        services: [
          { id: 'display', title: 'Display & Touchscreen Repairs', icon: 'ri-smartphone-line', image: '/assets/android-repair-new.jpg', description: 'Complete display repair solutions for all OnePlus models.', subServices: [{ title: 'Screen Repairs', description: 'Solutions for cracked glass, flickering, and liquid damage.', features: ['Screen replacement', 'Touch calibration', 'Ghost-touch fix', 'Backlight issues'] }] }
        ]
      }}
      features={{
        title: "Why Choose Device Doctor for OnePlus Repairs",
        subtitle: "Experience the difference with our certified technicians, genuine parts, and exceptional service quality.",
        badgeText: "Why Choose Us",
        theme: "alternative",
        items: [
          { icon: 'ri-user-star-line', title: 'Certified OnePlus-trained technicians', description: 'with hands-on experience' },
          { icon: 'ri-shield-check-line', title: '100% genuine and brand-approved', description: 'spare parts' },
          { icon: 'ri-time-line', title: 'Same-day service', description: 'for most screen, battery, and charging issues' },
          { icon: 'ri-search-line', title: 'Free diagnostics', description: '& transparent pricing policy' },
          { icon: 'ri-truck-line', title: 'All-Kerala Courier', description: 'Convenient courier service available across Kerala.' },
          { icon: 'ri-award-line', title: '1-month service warranty', description: 'on all repairs and replacements' }
        ]
      }}
      models={{
        title: "OnePlus Models We Service",
        subtitle: "We service all OnePlus models, including the latest flagships and classic devices.",
        categories: [
          { title: 'OnePlus Flagship Series', icon: 'ri-smartphone-line', models: ['OnePlus 11', 'OnePlus 10 Pro', 'OnePlus 9'], color: 'bg-red-500' },
          { title: 'OnePlus Nord Series', icon: 'ri-phone-line', models: ['OnePlus Nord 3', 'OnePlus Nord CE 3'], color: 'bg-blue-500' }
        ]
      }}
      testimonials={{
        items: [
          { name: 'Rahul P.', location: 'Kochi', rating: 5, text: 'I had my OnePlus 8 screen fixed in a few hours. The service was fast, genuine, and affordable.', service: 'Screen Replacement' },
          { name: 'Neha M.', location: 'Edappally', rating: 5, text: 'Battery and charging problems solved perfectly. Honest pricing and great communication!', service: 'Battery Replacement' }
        ]
      }}
      faq={{
        items: [
          { question: "How long will my OnePlus repair take?", answer: "Most display or charging repairs are completed same day. Major hardware issues may take 1–2 days." },
          { question: "Are the parts genuine?", answer: "Yes. We use original OnePlus components sourced from brand-approved suppliers." }
        ]
      }}
      cta={{
        title: "Ready to Fix Your OnePlus?",
        subtitle: "Contact Device Doctor – Best OnePlus Service Centre in Kochi. Call now or book online for same-day service and All-Kerala Courier Services.",
        themeColor: "red"
      }}
    />
  );
};

export default OnePlusServicePage;
export { OnePlusServicePage };